var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRed1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 6.66699H5.66675M5.66675 6.66699H21.6667M5.66675 6.66699V20.667C5.66675 21.1974 5.87746 21.7061 6.25253 22.0812C6.62761 22.4563 7.13632 22.667 7.66675 22.667H17.6667C18.1972 22.667 18.7059 22.4563 19.081 22.0812C19.456 21.7061 19.6667 21.1974 19.6667 20.667V6.66699M8.66675 6.66699V4.66699C8.66675 4.13656 8.87746 3.62785 9.25253 3.25278C9.62761 2.87771 10.1363 2.66699 10.6667 2.66699H14.6667C15.1972 2.66699 15.7059 2.87771 16.081 3.25278C16.456 3.62785 16.6667 4.13656 16.6667 4.66699V6.66699M10.6667 11.667V17.667M14.6667 11.667V17.667",
    stroke: "#D92D20",
    strokeWidth: 1.71771,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed1);
export default __webpack_public_path__ + "static/media/delete-red1.fe6b93a7168993c950103ddb8d14cdbf.svg";
export { ForwardRef as ReactComponent };